module.exports = "/_next/static/images/ledServices-bee051e36662efcdf0a54d79fb5a76ae.png";